import { Component, HostBinding, OnInit, signal } from '@angular/core';
import { SidebarToggleObservable } from 'src/app/core/service/observable.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false,
})
export class SidebarComponent implements OnInit {
    isExpanded = signal(true);

    @HostBinding('class.collapsed')
    get collapsed() {
        return !this.isExpanded();
    }

    constructor(private sidebarToggleObservable: SidebarToggleObservable) {}

    ngOnInit() {
        const savedExpanded = localStorage.getItem('sidebarExpanded');

        if (savedExpanded !== null) {
            this.isExpanded.set(JSON.parse(savedExpanded));
        }
    }

    toggleSidebar = () => {
        const newState = !this.isExpanded();
        console.log('🔍 SIDEBAR DEBUG - toggling from', this.isExpanded(), 'to', newState);
        this.isExpanded.update((isExpanded) => !isExpanded);
        localStorage.setItem(
            'sidebarExpanded',
            JSON.stringify(this.isExpanded())
        );
        if (newState) {
            this.sidebarToggleObservable.showSidebar();
        } else {
            this.sidebarToggleObservable.hideSidebar();
        }
    };
}
